import { RootState } from 'src/store/store'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { commonUtils } from 'src/utils/common.utils'
import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import useMatchHook from 'src/hooks/useMatch.hook'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useLocation, useNavigate } from 'react-router-dom'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useEffect, useState } from 'react'

import { Cmdtypes } from 'src/constants/cmdtypes'

import { RequestDataBody } from 'src/types/websocket'
import { SocketSender } from 'src/api/socket'

const ExplorerHeader = (props: { text: string; $margin: string; curPage?: number; setCurPage?: (page: number) => void }) => {
  const { currentMedia } = useMediaQueryHook()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { Path } = useAppSelector((state: RootState) => state.explorerFileList)
  const { m_explorer_delete, m_explorer_detail_param, m_explorer_detail } = useMatchHook()
  const { externalDefaultPath, DownloadsDefaultPath, InternalDefaultPath } = commonUtils
  const { pathname } = useLocation()
  const [tempPath, setTempPath] = useState<string>('')

  const NavigationHandler = () => {
    switch (pathname) {
      case m_explorer_delete?.pathname:
        navigate('/explorer')
        break
      case m_explorer_detail?.pathname:
        switch (true) {
          case m_explorer_detail_param === 'INTERNAL' &&
            Path !== '' &&
            Path !== InternalDefaultPath:
          case m_explorer_detail_param === 'EXTERNAL' &&
            Path !== '' &&
            Path !== externalDefaultPath:
          case m_explorer_detail_param === 'Downloads' &&
            Path !== '' &&
            Path !== DownloadsDefaultPath:
            dispatch(
              SocketSender<RequestDataBody.ExplorerFileInnerList>(Cmdtypes.EXPLORER_FOLDER_INNER, {
                Path: tempPath,
                Page: 1,
              }),
            )
            if (props.setCurPage) {
              props.setCurPage(1)
            }
            break
          default:
            navigate('/explorer')
            break
        }
        break
      default:
        break
    }
  }

  useEffect(() => {
    const tempArray = Path?.split('/')
    tempArray?.pop()
    setTempPath(`${tempArray?.join('/')}`)
  }, [Path])

  const PcExplorerHeader = () => {
    return (
      <Div display={'flex'} $margin={props.$margin} height={'30px'}>
        <Svg name={'reverse_arrow'} width={'28'} height={'28'} onClick={NavigationHandler} />
        <Span option={'mediumLarge_bold'} $text_align={'center'} $margin={'0 35px 0 0'}>
          {props.text}
        </Span>
      </Div>
    )
  }
  const MoExplorerHeader = () => {
    return (
      <Div
        style={{
          position: 'absolute',
          zIndex: 9996,
          top: 0,
          left: '50%',
          transform: 'translate(-50%, 0)',
          width: '100%',
          background: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(2px)',
        }}
        $justify_content={'space-between'}
        display={'flex'}
        height={'48px'}
        $padding={'0 20px'}
        $margin={'0 auto'}
      >
        <Svg name={'reverse_arrow'} $margin={'13px 0'} onClick={NavigationHandler} />
        <Span $line_height={'48px'} option={'tiny_bold'}>
          {props.text}
        </Span>
      </Div>
    )
  }
  return <>{currentMedia === 'pc' ? <PcExplorerHeader /> : <MoExplorerHeader />}</>
}
export default ExplorerHeader
